import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalService } from './modal-service/modal.service';
import { CiudUserAuthData } from 'src/app/core/auth/authData.model';
import { AlertService } from 'src/app/services/alerts.service';
import { validateDocumentNumberByType } from '../../pages/register-page/validators/doc-number-by-type.validator';
import { sanitizeAndValidateInput } from '../../pages/register-page/validators/detect-html-tag-SQL.validator';

@Component({
  selector: 'app-modal-complete-user-data',
  templateUrl: './modal-complete-user-data.component.html',
  styleUrl: './modal-complete-user-data.component.scss'
})
export class ModalCompleteUserDataComponent {
  tiposDocumentos: string[] = ['Cédula de Ciudadanía', 'Pasaporte', 'Tarjeta de Identidad', 'Cédula de Extranjería', 'Permiso por Protección Temporal'];
  focusedInput: string = '';
  userDataForm: FormGroup;
  currentUser:  CiudUserAuthData | null = null;

  constructor(
    public dialogRef: MatDialogRef<ModalCompleteUserDataComponent>,
    private fb: FormBuilder,
    private modalService: ModalService,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Inicialización del formulario con validaciones
    this.userDataForm = this.fb.group({
      tipoDocIdent: ['', Validators.required],
      numDocIdent: ['', [Validators.required, sanitizeAndValidateInput()]],
      numTelefono: ['3', [Validators.required, Validators.pattern('^[3][0-9]{9}$'), Validators.minLength(10), Validators.maxLength(10), sanitizeAndValidateInput()]],
    },
    { validators: validateDocumentNumberByType() });
  }


  ngOnInit() {
    this.userDataForm.get('tipoDocIdent')?.valueChanges.subscribe(() => {
      this.userDataForm.get('numDocIdent')?.reset();
      this.userDataForm.get('numDocIdent')?.updateValueAndValidity();
    });
  }


  // Método para cancelar
  cancelar(): void {
    this.dialogRef.close();
  }

  onFocus(input: string) {
    this.focusedInput = input;
  }

  onBlur() {
      this.focusedInput = '';
  }

  // Método para confirmar (puedes manejar el envío del formulario aquí)
  submit(): void {
    if (this.userDataForm.valid) {

      const formValues = this.userDataForm.value;
      const user = JSON.parse(sessionStorage.getItem('user') ?? '{}');

      // Ahora, puedes acceder a las propiedades de 'user' correctamente
      const ciudadano: CiudUserAuthData = {
        id_ciud: parseInt(user.id_ciud ?? ''),
        nombres: user.nombres ?? '',
        apellidos: user.apellidos ?? '',
        tipo_doc_ident: formValues.tipoDocIdent ?? '',
        num_doc_ident: formValues.numDocIdent ?? '',
        direccion: 'nulo',
        correo: user.correo ?? '',
        telefono: formValues.numTelefono ?? '',
      };

      this.dialogRef.close(formValues);

      this.modalService.updateMyProfile(ciudadano).subscribe({
        next: response => {
          if (response.success) {
            this.alertService.showAlert('Actualización de datos personales realizado exitosamente', 'success');
          } else {
            console.error('Error al actualizar el ciudadano:', response);
            this.alertService.showAlert('Error al actualizar los datos personales', 'error');
          }
        },
        error: error => {
          console.error('API error:', error);
          this.alertService.showAlert('Error al actualizar los datos e el backend', 'error');
        }
      })
    } else {
      this.alertService.showAlert('Por favor completa todos los campos', 'error');
    }
  }
}
